import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';
import { ReactNode } from 'react';

export interface PaymentSidebarItemProps {
  label: ReactNode;
  value: ReactNode;
  sx?: SxProps;
}

const paymentSidebarItemStyles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  value: {
    textAlign: 'right',
  },
};

export function PaymentSidebarItem({
  label,
  value,
  sx,
}: PaymentSidebarItemProps) {
  return (
    <Box
      sx={{
        ...paymentSidebarItemStyles.root,
        ...sx,
      }}
    >
      <Typography variant="body1">{label}</Typography>
      <Typography sx={paymentSidebarItemStyles.value} variant="body1">
        {value}
      </Typography>
    </Box>
  );
}
